import PubSub from "underpub-js";

var BannerSimple = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-BannerSimple',
	};

	$.extend(true, this.options, options);

};

BannerSimple.prototype.init = function() {

	var self = this;

};

export default BannerSimple;
